import type { BatchData } from '../types';
import MetaField from './MetaField';

interface Props {
  data: BatchData;
  onPatch: (patch: Partial<BatchData>) => void;
  onFocusField: (fieldId: string | null) => void;
}

export default function ProcessParametersCard({ data, onPatch, onFocusField }: Props) {
  return (
    <div className="card">
      <div className="card-header">
        <span className="card-title">Process Parameters</span>
      </div>
      <div className="card-body">
        <div className="field-grid fg-4">
          <MetaField label="Processing temp (°C)" id="metaTemp" type="number" placeholder="70–80" data={data} onPatch={onPatch} onFocusField={onFocusField} />
          <MetaField label="Cool-down temp (°C)" id="metaCoolTemp" type="number" placeholder="40" data={data} onPatch={onPatch} onFocusField={onFocusField} />
          <MetaField label="Mix time (mins)" id="metaMixTime" type="number" placeholder="10" data={data} onPatch={onPatch} onFocusField={onFocusField} />
          <MetaField label="Mix speed / method" id="metaMixMethod" placeholder="e.g. Low speed / spatula" data={data} onPatch={onPatch} onFocusField={onFocusField} />
          <MetaField label="Emulsification method" id="metaEmulsify" placeholder="e.g. Hand mix, hot-cold" data={data} onPatch={onPatch} onFocusField={onFocusField} />
          <MetaField label="pH target" id="metaPHTarget" placeholder="e.g. 5.0–6.0" data={data} onPatch={onPatch} onFocusField={onFocusField} />
          <MetaField label="pH measured" id="metaPHMeasured" placeholder="e.g. 5.4" data={data} onPatch={onPatch} onFocusField={onFocusField} />
          <MetaField label="pH adjuster" id="metaPHAdjuster" placeholder="e.g. Citric acid" data={data} onPatch={onPatch} onFocusField={onFocusField} />
          <MetaField label="Viscosity / texture" id="metaViscosity" placeholder="e.g. Light, watery" data={data} onPatch={onPatch} onFocusField={onFocusField} />
          <MetaField label="Equipment used" id="metaEquipment" placeholder="e.g. Double boiler, immersion blender" data={data} onPatch={onPatch} onFocusField={onFocusField} className="span2" />
        </div>
      </div>
    </div>
  );
}
